/** Mirrors the server-side LAYER_REGISTRY; update both when adding layers. */
export const LAYER_OPTIONS = [
  { id: 'hotels', displayName: 'מלונות' },
  { id: 'entrepreneurs', displayName: 'שכבת יזמים' },
  { id: 'agritour-entrepreneurs', displayName: 'בקשות קול קורא תיירות חקלאית' },
] as const;

export function getLayerDisplayName(layerId: string): string {
  return LAYER_OPTIONS.find((l) => l.id === layerId)?.displayName ?? layerId;
}

/** UI hints only — sync rows are created via POST /api/sync/layers/:layerId. */
export const LAYER_SYNC_HINTS: Record<
  string,
  { boardHint: string; suggestedTargetUrl?: string }
> = {
  hotels: {
    boardHint: 'מזהה לוח Monday — Tourism 360 מקרו (5097499232). המפה קוראת מהלוח בלבד.',
    suggestedTargetUrl:
      'https://services7.arcgis.com/TqAIBBIELxtowFsr/arcgis/rest/services/%D7%9E%D7%9C%D7%95%D7%A0%D7%95%D7%AA/FeatureServer',
  },
  entrepreneurs: {
    boardHint: 'מזהה לוח Monday — תיקי יזמים',
  },
  'agritour-entrepreneurs': {
    boardHint: 'מזהה לוח Monday — קול קורא תיירות חקלאית (5098952022)',
  },
};

/** Auto-refresh interval for Monday-backed map layers (ms). */
export const ENTREPRENEURS_LAYER_POLL_MS = 60_000;
export const AGRITOUR_ENTREPRENEURS_LAYER_POLL_MS = 60_000;
export const HOTELS_LAYER_POLL_MS = 60_000;
